import { FC } from 'react';
import { Box, StyleProps, Text } from '@chakra-ui/react';

import earthImg from 'assets/brand/earth.png';
import SunshineTag from 'components/_core/SunshineTag';
import Skeleton from 'components/Skeleton';
import useTeamMembersInvitationQuota from 'features/Team/hooks/useTeamMembersInvitationQuota';

import locales from './locales';

const styles: StyleProps = {
  alignItems: 'flex-start',
  bgColor: 'blue.200',
  bgPos: 'bottom -2.75rem right -3.5rem',
  bgRepeat: 'no-repeat',
  bgSize: '180px',
  borderRadius: 'radius-8',
  gap: 'space-8',
  padding: 'space-16',
  width: 'full',
};

const PayPerSeatMarketingCallout: FC = () => {
  const { invitationsLeft, loading } = useTeamMembersInvitationQuota();

  return (
    <Box {...styles} bgImage={earthImg}>
      <Text fontWeight="weight-500" size="md" variant="primary">
        {locales.title}
        <>
          &nbsp;
          <SunshineTag colorScheme="green" paddingY="space-0" size="sm">
            {locales.new}
          </SunshineTag>
        </>
      </Text>
      <Skeleton isLoaded={!loading}>
        <Text size="sm">
          {locales.formatString(locales.content, {
            invitationsLeft,
          })}
        </Text>
      </Skeleton>
    </Box>
  );
};

export default PayPerSeatMarketingCallout;
